__turbopack_context__.v({
  "cassetteImage": "page-module-scss-module__FTWCrW__cassetteImage",
  "contactPage": "page-module-scss-module__FTWCrW__contactPage",
  "container": "page-module-scss-module__FTWCrW__container",
  "detailedForm": "page-module-scss-module__FTWCrW__detailedForm",
  "fileFormGroup": "page-module-scss-module__FTWCrW__fileFormGroup",
  "fileInput": "page-module-scss-module__FTWCrW__fileInput",
  "fileLabel": "page-module-scss-module__FTWCrW__fileLabel",
  "floating": "page-module-scss-module__FTWCrW__floating",
  "focused": "page-module-scss-module__FTWCrW__focused",
  "formGroup": "page-module-scss-module__FTWCrW__formGroup",
  "formRow": "page-module-scss-module__FTWCrW__formRow",
  "formSection": "page-module-scss-module__FTWCrW__formSection",
  "imageSection": "page-module-scss-module__FTWCrW__imageSection",
  "input": "page-module-scss-module__FTWCrW__input",
  "label": "page-module-scss-module__FTWCrW__label",
  "option": "page-module-scss-module__FTWCrW__option",
  "options": "page-module-scss-module__FTWCrW__options",
  "proceedButton": "page-module-scss-module__FTWCrW__proceedButton",
  "question": "page-module-scss-module__FTWCrW__question",
  "questionTitle": "page-module-scss-module__FTWCrW__questionTitle",
  "rotate": "page-module-scss-module__FTWCrW__rotate",
  "selected": "page-module-scss-module__FTWCrW__selected",
  "slideIn": "page-module-scss-module__FTWCrW__slideIn",
  "step2": "page-module-scss-module__FTWCrW__step2",
  "submitButton": "page-module-scss-module__FTWCrW__submitButton",
  "subtitle": "page-module-scss-module__FTWCrW__subtitle",
  "textarea": "page-module-scss-module__FTWCrW__textarea",
  "title": "page-module-scss-module__FTWCrW__title",
});
